import set from "lodash/set";
import merge from "lodash/merge";
import { diff } from "deep-object-diff";

export const useThemeCustom = ({ data, onChangeData }) => {
  const setData = (path, value) => {
    const customStored = localStorage.getItem("customTheme");
    const oldData = JSON.parse(JSON.stringify(data));
    const newData = set({ ...data }, path, value);

    const difference = diff(oldData, newData);

    if (customStored) {
      localStorage.setItem(
        "customTheme",
        JSON.stringify(merge(JSON.parse(customStored), difference))
      );
    } else {
      localStorage.setItem("customTheme", JSON.stringify({ ...difference }));
    }

    onChangeData({ ...newData });
  };

  return {
    setData,
  };
};
